const FEATURE_HELP_URLS = {
  agent_bots: 'https://apologia.help/agent-bots',
  agents: 'https://apologia.help/agents',
  audit_logs: 'https://apologia.help/audit-logs',
  campaigns: 'https://apologia.help/campaigns',
  canned_responses: 'https://apologia.help/canned',
  channel_email: 'https://apologia.help/email',
  channel_facebook: 'https://apologia.help/fb',
  custom_attributes: 'https://apologia.help/custom-attributes',
  dashboard_apps: 'https://apologia.help/dashboard-apps',
  help_center: 'https://apologia.help/help-center',
  inboxes: 'https://apologia.help/inboxes',
  integrations: 'https://apologia.help/integrations',
  labels: 'https://apologia.help/labels',
  macros: 'https://apologia.help/macros',
  message_reply_to: 'https://apologia.help/reply-to',
  reports: 'https://apologia.help/reports',
  sla: 'https://apologia.help/sla',
  team_management: 'https://apologia.help/teams',
  webhook: 'https://apologia.help/webhooks',
  billing: 'https://chwt.app/pricing',
  saml: 'https://apologia.help/saml',
  captain_billing: 'https://apologia.help/captain_billing',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
